import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { LegalRepresentativeModel } from 'src/app/Model/LegalRepresentative.model';
import { PartnersModel } from 'src/app/Model/Partners.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestIdentificationModel } from 'src/app/Model/RequestIdentification.model';
import { RequestUpdateService } from 'src/app/Services/Request-update/requestUpdate.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import { MatTableHelpers } from 'src/app/Util/MatTableHelpers';

@Component({
  selector: 'app-agency-update',
  templateUrl: './agency-update.component.html',
  styleUrls: ['./agency-update.component.css']
})
export class AgencyUpdateComponent implements OnInit {

  public identificacion: RequestIdentificationModel;
  public legalRepresentative: LegalRepresentativeModel;
  public partners : PartnersModel[];
  private iata : string;
  lstDocTypes: DocumentTypeModel[];
  displayedColumns: string[] = ['actions','firstname', 'secondname', 
    'firstlastname', 'secondlastname','DocumentNumber', 'Percentage'];
  dataSource: MatTableDataSource<PartnersModel>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  public identificacionForm = new FormGroup({
    razonSocial : new FormControl('',[Validators.required,
      Validators.maxLength(150),
      CustomValidators.emptyTextValidator()]),
    nombre: new FormControl('',[Validators.required,
      Validators.maxLength(150),
      CustomValidators.emptyTextValidator()]),
    direccion : new FormControl('',[Validators.required,
      Validators.maxLength(200),
      CustomValidators.emptyTextValidator()]),
    tipoDocumento : new FormControl('',Validators.required),
    id: new FormControl('',[
      Validators.required,
      Validators.maxLength(20),
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlySiglaValidator()])
  })

  get razonSocial() { return this.identificacionForm.get('razonSocial'); }
  get nombre() { return this.identificacionForm.get('nombre'); }
  get direccion() { return this.identificacionForm.get('direccion'); }
  get tipoDocumento() { return this.identificacionForm.get('tipoDocumento'); }
  get id() { return this.identificacionForm.get('id'); }

  public representanteForm = new FormGroup({
    nombre1: new FormControl('',[Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150),]),
    nombre2: new FormControl('',[
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150)]),
    apellido1 : new FormControl('',[Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150)]),
    apellido2 : new FormControl('',[
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150)]),
    tipoId: new FormControl('',Validators.required),
    idRepresentante: new FormControl('',[Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlySiglaValidator(),
      Validators.maxLength(30)]),
    email : new FormControl('',[Validators.required,
      CustomValidators.emailValidator(),
      Validators.maxLength(500)])
  })

  get nombre1() { return this.representanteForm.get('nombre1'); }
  get nombre2() { return this.representanteForm.get('nombre2'); }
  get apellido1() { return this.representanteForm.get('apellido1'); }
  get apellido2() { return this.representanteForm.get('apellido2'); }
  get tipoId() { return this.representanteForm.get('tipoId'); }
  get idRepresentante() { return this.representanteForm.get('idRepresentante'); }
  get email() { return this.representanteForm.get('email'); }

  constructor(private readonly activeRoute: ActivatedRoute,private readonly requestUpdate : RequestUpdateService) { }

  ngOnInit(): void {

    if(this.activeRoute.snapshot.params.iata != null){
      this.iata = this.activeRoute.snapshot.params.iata
      this.loadFromCRM()
    }

    this.identificacion = new RequestIdentificationModel();
    this.legalRepresentative = new LegalRepresentativeModel();
    this.partners = [];
  }

  async loadFromCRM(){
    //identificacion agencia
    await this.requestUpdate.getIataIdentification(this.iata).then(res => {  
      this.identificacion = res
    })

    await this.requestUpdate.getIataRepresentative(this.iata).then(res => {  
      this.legalRepresentative = res
    })

    await this.requestUpdate.getIataPartners(this.iata).then(res => {  
      this.partners = res
    })

    this.dataSource = new MatTableDataSource(this.partners);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (data, sortHeaderId: string) => {
      return MatTableHelpers.getPropertyByPath(data, sortHeaderId);
    };
  }

}


//-----------------------------------------------------------------------------
// Partners modal
//-----------------------------------------------------------------------------
export class DataModal {
  public Request: RequestModel;
  public Partner: PartnersModel;
}

@Component({
  selector: 'app-agency-update',
  templateUrl: './agency-update-partners-dialog.component.html',
  styleUrls: ['./agency-update.component.css']
})
export class AgencyUpdatePartnersDialogComponent {
  partner: PartnersModel;
  @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal;


  public accionistas = new FormGroup({
    primerNombre: new FormControl('',[Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150)]),
    segundoNombre: new FormControl('',CustomValidators.lettersOnlyValidator()),
    primerApellido : new FormControl('',[Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150)]),
    segundoApellido: new FormControl('',CustomValidators.lettersOnlyValidator()),
    idAccionista: new FormControl('',[Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlySiglaValidator(),
      Validators.maxLength(30)]),
    porcentaje : new FormControl('',[Validators.required,
      Validators.max(100),
      Validators.min(1)])
  })

  get primerNombre() { return this.accionistas.get('primerNombre'); }
  get segundoNombre() { return this.accionistas.get('segundoNombre'); }
  get primerApellido() { return this.accionistas.get('primerApellido'); }
  get segundoApellido() { return this.accionistas.get('segundoApellido'); }
  get idAccionista() { return this.accionistas.get('idAccionista'); }
  get porcentaje() { return this.accionistas.get('porcentaje'); }

  constructor(){
    this.partner = new PartnersModel();
  }

}
